import React from "react";

export default ({ name, placeholder, value, onChange, isDisabled, isError, className, opts, rows = 4 }) => {
	return <textarea {...opts} name={name} placeholder={placeholder} disabled={isDisabled} onChange={onChange} rows={rows} value={value} className={`form-control textbox-kc${isError ? " textbox-kc-error" : ""} ${className}`} />;
};
